import Model from '../../ModelBinding/Model';
import ContactCollection from './ContactCollection';
import dayjs from 'dayjs';

export default class Contact extends Model {
  public firstname?: string;
  public lastname?: string;
  public email?: string;
  public phone_1?: string;
  public phone_2?: string;
  public phone_3?: string;
  public legal_name?: string;
  public locale?: string;
  public priority?: number;
  public created_at?: dayjs.Dayjs;
  public updated_at?: dayjs.Dayjs;

  bind() {
    this.firstname = this.getStringAttribute('firstname');
    this.lastname = this.getStringAttribute('lastname');
    this.email = this.getStringAttribute('email');
    this.phone_1 = this.getStringAttribute('phone_1');
    this.phone_2 = this.getStringAttribute('phone_2');
    this.phone_3 = this.getStringAttribute('phone_3');
    this.legal_name = this.getStringAttribute('legal_name');
    this.priority = this.getIntAttribute('priority');
    this.created_at = this.getDateAttribute('created_at');
    this.updated_at = this.getDateAttribute('updated_at');
    this.locale = this.getStringAttribute('locale');
  }

  static getCollection() {
    return ContactCollection;
  }
}
